import AssetTable from './AssetTable';

export * from './AssetTable.constants';
export { AssetTable };
export default AssetTable;
